import { useEffect, useState } from 'react';
import { userList } from 'Utils/Helpers/TableColumns';
import { useSelector } from 'react-redux';
import DataGridComponent from 'Utils/Helpers/DataGridComponent';
import NewUser from './components/New';

export default function UsersIndex() {
    const [data, setData] = useState();
    const [column, setColumn] = useState([]);
    const [newUser, setNewUser] = useState(false);
    const { total, current } = useSelector((state) => ({
        total: state.staff.total,
        current: state.staff.current,
    }));
    useEffect(() => {
        if(current && current.length !== 0 && current[3][0]) {
            if(total) {
                setData(total);
            }
            setNewUser(current[3][5]);
            if(!current[3][1] && !current[3][2] && !current[3][3] && !current[3][4]) {
                let _new = userList;
                _new.splice(2,1);
                setColumn(_new)
            } else {
                let _new = userList;
                let w = 0;
                if(current[3][1]) w+=40;
                if(current[3][2]) w+=40;
                if(current[3][3]) w+=40;
                if(current[3][4]) w+=40;
                _new[2].width = w;
                setColumn(_new)
            }
        }
    }, [total, current])

    return (
        <div className='content'>
            <div className="w-100">
                {
                    (data && data.length !== 0 && column.length !==0) ? 
                    <DataGridComponent
                        data={data}
                        columns={column}
                        className={'h-normal'}
                    /> : <div className='w-100 text-center pt-4'>
                        <small>{"اطلاعاتی برای نمایش وجود ندارد"}</small>
                    </div>
                }
            </div>
            {newUser && <NewUser />}
        </div>
    );
}